import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const tourParticipantsApiQueryKeys = {
  tourParticipants: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, 'participants'] as const,
};
